import { DtoType } from '@core/data/dto/dto-types';
import { Dto } from '@core/data/dto/dto';
import { DTO_DEFAULT } from '@core/data/dto/dto-types';
import { DtoForceConstructor, DtoImport, DtoExport } from '@core/utils/dto';
import { DocumentSchema } from './document.schema';
import { Moment } from 'moment';
import { DocumentStatus } from './document-status';

@DtoForceConstructor
export class Document {

    public id: string;
    public year: number;
    public type: string;
    public description: string;
    public quarter: string;
    public label: string;
    public date: Moment;
    public filedOn: Moment;
    public provider: string;
    public providerId: string;
    public title: string;
    public jurisdiction: string;
    public status: DocumentStatus

    @DtoImport(DocumentSchema)
    static import(dto: Dto): any {
        return new Document(dto);
    }

    constructor(value?: any) {
        if (value) {
            const properties: string[] = Object.keys(value);

            properties.forEach((property: string) => {
                this[property] = value[property];
            });
        }
    }

    @DtoExport([
        {
            type: DTO_DEFAULT,
            dto: DocumentSchema,
        },
    ])
    export(type?: DtoType): any {}
}
